import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

function getContainer(container) {
  return typeof container === 'function' ? container() : container || null;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal = function Portal(_a) {
  var container = _a.container,
      onRendered = _a.onRendered,
      children = _a.children;

  var _b = useState(null),
      mountNode = _b[0],
      setMountNode = _b[1];

  useEffect(function () {
    onRendered && onRendered(mountNode);
  }, [mountNode, onRendered]);
  useEffect(function () {
    setMountNode(getContainer(container) || document.body);
  }, [container]);
  return mountNode ? ReactDOM.createPortal(children, mountNode) : null;
};

export default Portal;